module.exports = ".page-header .filter::after {\n  background-color: rgba(0, 0, 0, 0); }\n"